// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a3wAvHm6KQ2JJLBguHah{display:flex;align-items:center;gap:8px;margin-top:24px}", "",{"version":3,"sources":["webpack://./src/pages/cp/conversations/components/alertDialog/index.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CACA,eAAA","sourcesContent":[".ctas {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctas": "a3wAvHm6KQ2JJLBguHah"
};
export default ___CSS_LOADER_EXPORT___;
